module.exports = __webpack_public_path__ + "static/media/home2-slider-6.397741ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home2-slider-6.jpg
// module id = 1153
// module chunks = 33